import { offers } from '../../../content/career/cards';
import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';

export const Offer: React.FC = () => (
  <section className={cx('main_section_offer')}>
    <div className={cx('padding-global padding-section-medium')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_offer')}>
          <div className={cx('main_offer_h2-wrapper')}>
            <h2>
              <span className={cx('text-color-brand-blue')}>{'Больше,'}</span>
              {' чем предложение о работе'}
            </h2>
            <div className={cx('spacer-medium')}></div>
            <div className={cx('text-size-large')}>
              {'Даём всё, что помогает тебе '}
              <br />
              {'сохранять фокус и драйв.'}
            </div>
            <img
              src={media.mainOfferStar1}
              loading="lazy"
              sizes="100vw"
              srcSet={[
                media.mainOfferStar1P500 + ' 500w',
                media.mainOfferStar1P800 + ' 800w',
                media.mainOfferStar1P1080 + ' 1080w',
                media.mainOfferStar1 + ' 1365w',
              ].join(', ')}
              alt=""
              className={cx('main_offer_cat')}
            />
          </div>
          <div className={cx('spacer-medium')}></div>
          <div className={cx('main_offer_cards-grid')}>
            {offers.map(offer => (
              <article key={offer.title} className={cx('main_offer_card')}>
                <div className={cx('main_offer_h3-wrapper ' + offer.color)}>
                  <h3>{offer.title}</h3>
                </div>
                <p>{offer.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
